export const utility = function () {
  var $;
  $ = document.querySelectorAll.bind( document );
  
  /**
   *
   */
  function showScrollingButton( element, heightToShow ) {
    const y = window.scrollY;

    if ( y >= heightToShow ) {
      element.classList.add( "show" );

    } else {
      element.classList.remove( "show" );
    }
  }

  var social_media_share_button = document.getElementById( 'button-social-media-share' );
  var back_to_top_button = document.getElementById( 'button-back-to-top' );

  window.addEventListener( 'scroll', function() {
    if ( document.body.contains( social_media_share_button ) ) {
      showScrollingButton( social_media_share_button, window.innerHeight * 0.5 );
    }

    showScrollingButton( back_to_top_button, window.innerHeight * 0.5 );
  } );

  back_to_top_button.addEventListener( 'click', function() {
    scrollPageTo( 0 );
  } );
}

/**
   *
   */
function scrollPageTo( to, duration = 600 ) {
  const easeOutQuad = function ( t, b, c, d ) {
    t /= d;
    return -c * t * ( t - 2 ) + b;
  };

  return new Promise( ( resolve, reject ) => {
    const element = document.scrollingElement;

    if ( typeof to === 'string' ) {
      to = document.querySelector( to ) || reject();
    }

    if ( typeof to !== 'number' ) {
      to = to.getBoundingClientRect().top + element.scrollTop;
    }

    let start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    const animateScroll = function() {
      currentTime += increment;

      let val = easeOutQuad( currentTime, start, change, duration );

      element.scrollTop = val;

      if ( currentTime < duration ) {
        setTimeout( animateScroll, increment );

      } else {
        resolve();
      }
    };

    animateScroll();
  });
};

/**
   *
   */
export const toggleScrollToSection = function( offset, buttons = null ) {
  if ( !buttons ) {
    var buttons = document.getElementsByClassName( 'toggle-scroll-to-section' );
  }

  var scrollToDownload = function( e ) {
    e.preventDefault();

    var section;
    if ( e.currentTarget.getAttribute( 'data-section' ) ) {
      section = e.currentTarget.getAttribute( 'data-section' );

    } else {
      var url = e.currentTarget.getAttribute( 'href' ).toString();
      var hash_index = url.indexOf( '#' );

      section = url.slice( hash_index + 1 );
    }

    var element = document.getElementById( section );

    var bodyRect = document.body.getBoundingClientRect(),
        elemRect = element.getBoundingClientRect(),
        target   = elemRect.top - ( bodyRect.top + offset );

    scrollPageTo( target );
  }

  for (var i = 0; i < buttons.length; i++ ) {
    buttons[i].addEventListener( 'click',  scrollToDownload );
  }
}